/**
 * Created by Johan Schram - KOSMEO ANALYTICS - https://kosmeo-a.com on 16/05/2017.
 */
var React = require('react');

var modeTransportClass = class {
    constructor() {
        this.data = [
                {
                    id : 0,
                    icone : <span className="fa fa-train fa-lg"></span>,
                    otp : ["TRANSIT","WALK"],
                    label : "Transports en commun"
                },
                {
                    id : 1,
                    icone : <span className="fa fa-car fa-lg"></span>,
                    otp : ["WALK","CAR"],
                    label : "Voiture"
                },
                {
                    id : 2,
                    icone : <span className="fa fa-bicycle fa-lg"></span>,
                    otp : ["BICYCLE"],
                    label : "Vélo"
                },
                {
                    id : 3,
                    icone : <span className="fa fa-male fa-lg"></span>,
                    otp : ["WALK"],
                    label :  "Marche à pied"
                }
            ]
    }

    getOTPCode(id){
        for (var item of this.data){
            if (item.id === id) {
                return item.otp
            }
        }
        return '';
    }

    getTransportLib(){
        return this.data.map(function(item){
            return {lib : item.icone, id : item.id}
        });
    }

};
var modeTransport = new modeTransportClass();

var ParticipantClass = class {
    constructor(id, data) {

        this.transp = 0;
        this.adress = '';
        this.coord = { 0: '', 1 : ''};
        this.id = id;
        this.valid = false;

        if (data) {
            if (data.coord){
                this.coord = { 0: data.coord[0], 1 : data.coord[1]};
            }
            if (data.adress){
                this.adress = data.adress
            }
            if (data.adress && data.coord){
                this.valid = true;
            }
            if (data.transp !== undefined && data.transp >-1){
                this.transp = data.transp;
            }
        }
    }
};

var ParticipantsClass = class {
    constructor(numbers) {
        this.list = [];
        this.valid = false;
        this.maxid = 0
    }

    add(number){
        if (!number) {
            let id = this.maxid + 1;
            this.list.push(new ParticipantClass(id));
            this.valid = false;
            this.maxid = id;
        }
        else {
            for (var i =0; i < number; i++){
                let id = this.maxid + 1;
                this.list.push(new ParticipantClass(id));
                this.valid = false;
                this.maxid = id;
            }
        }
    }

    addWithData(data){
        try{
            var id = -1;
            if (data){
                for (var part of this.list){
                    if (part.adress === ''){
                        id = part.id;
                        break;
                    }
                }
                if (id > -1 ){
                    this.modifyParticipant({
                        id : id,
                        adress : data.adress,
                        coord : data.coord
                    })
                }
                else {
                    id = this.maxid + 1;
                    this.list.push(new ParticipantClass(id, data));
                    this.valid = false;
                    this.maxid = id;
                }
                return id;
            }
            else {
                return null;
            }
        }
        catch(err){
            return null;
        }
    }

    deleteParticipant(id){
        var position = -1;
        for(var i = 0; i < this.list.length; i++) {
            if (this.list[i].id === id) {
                position = i;
                break;
            }
        }
        if (position !== -1){
            this.list.splice(position,1);
        }
    }

    getParticipant(id){

        if (!(id >-1)){
            return null;
        }

        for(let participant of this.list) {
            if (participant.id === id) {
                return participant;
            }
        }

        return null;
    }

    modifyParticipant(item){

        if (!(item.id >-1)){
            return;
        }

        for(let participant of this.list) {
            if (participant.id === item.id) {
                for (var param in item) {
                    if (participant[param] !== 'undefined' && param!== 'id'){
                        participant[param] = item[param];
                    }
                }

                if (participant.coord){
                    if (participant.coord[0] && participant.coord[1]){
                        participant.valid = true;
                    }
                    else {
                        participant.valid = false;
                    }
                }
                else {
                    participant.valid = false;
                }


                break;
            }
        }

    }

    getQueryForIsochrone(){
        var res = {
            points : [],
            mode : [],
            date : '4-18-2017',  //meetDateAndTime.getDateForQuery(),
            time : meetDateAndTime.getTimeForQuery() //'20:00:00'
        };

        for (var part of this.list){
            if (part.valid){
                res.points.push([part.coord[1], part.coord[0]]);
                res.mode.push(modeTransport.getOTPCode(part.transp));
            }
        }
        if (res.points.length > 1 ){
            return res
        }
        else {
            return []
        }
    }

    canBePloted(){
        if (this.list.length < 2){
            return false;
        }
        var nb_valid = 0;
        for (var part of this.list){
            if (part.valid){
                nb_valid += 1;
            }
        }
        if (nb_valid < 2){
            return false;
        }
        else {
            return true;
        }
    }

    clearAll(){
        this.list = [];
        this.valid = false;
    }

};

var meetDateAndTimeClass = class {

    constructor() {
        this.meetTime = this.initializeMeetTime();
        this.meetDate = this.initializeMeetDate();
        this.meetDateMin = this.initializeMeetDate(-30);
        this.meetDateMax = this.initializeMeetDate(+90);
    }

    initializeMeetDate(fromTodayDate){
        var date = new Date();

        if (fromTodayDate){
            date.setDate(date.getDate() + fromTodayDate);
        }

        var formatText = function(form, intInString){
            intInString = intInString.toString();
            while (intInString.length < form.length) {
                intInString = '0'+ intInString
            }
            return intInString;
        };

        return  date.getFullYear() +'-' + (formatText('00', date.getMonth() + 1)) +'-' + formatText('00', date.getDate());
    }

    initializeMeetTime(){
        var date = new Date();
        var formatText = function(form, intInString){
            intInString = intInString.toString();
            while (intInString.length < form.length) {
                intInString = '0'+ intInString
            }
            return intInString;
        };
        return  (formatText('00', date.getHours()) +':' + formatText('00', date.getMinutes()) );
    }

    updateDate(value){
        if (!value){}
        else {
            this.meetDate = value;
        }
    }

    updateTime(value){
        if (!value){}
        else {
            this.meetTime = value;
        }

    }

    getDateForQuery(){

        var dateArray = [];

        try{
            dateArray = this.meetDate.split("-");
            return parseInt(dateArray[1]) + '-' + parseInt(dateArray[2]) + '-' + parseInt(dateArray[0]);
        }
        catch(err){
            return '6-26-2017';
        }

    }

    getTimeForQuery(){
        var timeArray = [];

        try{
            timeArray = this.meetTime.split(":");
            return timeArray[0] + ':' + timeArray[1] + ':00';
        }
        catch(err){
            return '12:00:00';
        }
    }

};

//     date : '12-19-2016',
//     time:'12:00:00',

var participants = [];
var meetDateAndTime = null;
var initialized = false;

//------------------------------------------------------------------------------------------------------------------
// Initlaisation de la liste des participants
function initializeParticipants(force) {
    if (initialized && !force){
        return ;
    }
    participants = new ParticipantsClass();
    participants.add(2);
    initialized = true
}

function initializeMeetDateAndTime(){
    meetDateAndTime = new meetDateAndTimeClass()
}

initializeParticipants();

initializeMeetDateAndTime();

export default { participants, modeTransport, meetDateAndTime } ;



// WEBPACK FOOTER //
// ./src/services/participants.service.js